import { FilterdColumns } from '@oscar/table';
import { ROLE_USER_MANAGEMENT } from 'common/constants';
import React from 'react';
import './style.scss';

const { OptionGroup } = FilterdColumns;

function FilterRoleUserManagement(props: any) {
  return (
    <OptionGroup
      {...props}
      data={Object.values(ROLE_USER_MANAGEMENT).map(item => ({
        value: item.VALUE,
        label: item.TEXT,
      }))}
    />
  );
}

export default FilterRoleUserManagement;
